<template>
  <!--  头部姓名性别年龄手机输入块-->
  <div class="nameGenderAgePhonenumberPiece" v-if="$store.state.nowPatientInfo">
    <div class="addUserBox" v-if="userInfoShowBoxShow">
      <createOreditPatient @refresh-list="refreshList"  showType="read" :userInfoData="patient" type="编辑患者" @close="closeCreateOreditPatient"/>
    </div>
    <div class="userInfoInputPiece">
      <div class="marsk" v-if="patient.visitState === '02' || patient.id"></div>
      <div class="clearPatientInfo" v-if="patient.visitState === '00'&& patient.id" @click="clearPatientInfo()">
        <i class="el-icon-circle-close"></i>
      </div>
      <el-form :model="patient" :rules="$store.state.patientInfoFormRuleType === 1?patientRules:patientRules2" ref="ruleForm" class="patient-form" :validate-on-rule-change="false">
        <el-form-item prop="name" class="form-item-reset" :show-message="false">
          <div class="userNameBox">
            <span class="must">*</span>
            <i  v-if="patient.draftId" style="color: #DADBE0FF" class="el-icon-user-solid"></i>
            <i v-else style="color: #5199f8" class="el-icon-user-solid"></i>
            <el-input @blur="hideSearchPop" @focus="()=>{
              if(patient.name) {
                isOpenSearchPop = true
              }
            }" @input="changeUserName" v-model="patient.name" placeholder="姓名" class="userName" type="text"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="gender" class="form-item-reset" :show-message="false">
          <div class="genderBox">
            <span class="must">*</span>
            <img src="@/assets/img/genderIcon.png" class="genderIcon" alt="">
            <el-select v-model="patient.gender" placeholder="性别">
              <el-option label="男" value="NAN"></el-option>
              <el-option label="女" value="NV"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item prop="ageYear" class="form-item-reset" :show-message="false">
          <div class="ageBox">
            <el-input @input="setBirthday" type="text" :maxlength="3" v-numeric v-model="patient.ageYear" class="age"></el-input>
            <div class="label"><span class="must2" style="right: 15px">*</span>岁</div>
          </div>

        </el-form-item>
<!--        <el-form-item prop="ageMonth" class="form-item-reset" :show-message="false">-->
<!--          <div class="mounthBox">-->
<!--            <el-input @input="setBirthday"  maxlength="2" type="text" v-model="patient.ageMonth" class="mounth"></el-input>-->
<!--            <div class="label"><span class="must2" style="right: 15px">*</span>月</div>-->
<!--          </div>-->
<!--        </el-form-item>-->
        <el-form-item prop="height" class="form-item-reset" :show-message="false">
          <div class="weightBox">
            <el-input type="text" :maxlength="3" placeholder="身高"  v-model="patient.height"></el-input>
            <div class="label"><span class="must2">*</span>CM</div>
          </div>
        </el-form-item>
        <el-form-item prop="weight" class="form-item-reset" :show-message="false">
          <div class="weightBox">
            <el-input  type="text" :maxlength="3" placeholder="体重"  v-model="patient.weight"></el-input>
            <div class="label"><span class="must2">*</span>KG</div>
          </div>
        </el-form-item>
<!--        <el-form-item prop="phoneNumber" class="form-item-reset" style="width: 100px" :show-message="false">-->
<!--          <div class="phonenumberBox">-->
<!--            <el-input @blur="hideSearchPop" @focus="()=>{-->
<!--              if(patient.name) {-->
<!--                isOpenSearchPop = true-->
<!--              }-->
<!--            }" placeholder="手机号" inputmode="numeric" maxlength="11" @input="changePhonenumber" v-model="patient.phoneNumber" class="phonenumber" type="text"></el-input>-->
<!--          </div>-->
<!--        </el-form-item>-->
          <el-form-item  label=""  style="margin-left: 20px" prop="districtCode" :show-message="false">
            <div class="locationBox">
              <span class="must">*</span>
              <img src="@/assets/img/locationIcon.png" class="locationIcon" alt="">
              <el-cascader
                  placeholder="现居住地"
                  style="width: 200px"
                  v-model="cityCode"
                  :options="cityList"
                  @change="changeCity"></el-cascader>
            </div>
          </el-form-item>
          <el-form-item  label="" prop="job" style="margin-left: 20px" :show-message="false" >
            <div class="jobBox">
              <span class="must">*</span>
              <img src="@/assets/img/jobIcon.png" class="jobIcon" alt="">
              <el-select style="width: 160px" clearable allow-create filterable v-model="patient.job" placeholder="职业">
                <el-option
                    v-for="option in careerList"
                    :key="option.id"
                    :label="option.label"
                    :value="option.label">
                  <span style="float: left">{{ option.label }}</span>
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        <div class="promptInputBox" v-if="isOpenSearchPop && promptInputTableInfo.dataList.length!==0">
          <div class="tr-head">
            <div v-if="item.show" :class="'td-'+ item.code" v-for="item in promptInputTableInfo.thList" :code="item.code">{{item.label}}</div>
          </div>
          <div class="tableBody">
            <div class="tr" v-for="item in promptInputTableInfo.dataList" @click="setUnserInfo(item)">
              <div v-if="promptInputTableInfo.thList[0].show" class="td-name">{{item.name}}
                <img class="vipIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAZlBMVEUAAAD/////////////////////////////////////////////mTP//Pj/+fH/nDj/yZP/pEn/9uz/z53/xoz/wYL/oUL/njz/3Ln/06b/t27/rlv/8eP/6ND/06f/tWv/qVL/p09EncMsAAAAC3RSTlMA/Rvz8tm2m2tObpi/mcAAAADTSURBVCjPfVLZEsIgDEQqhZqFHvbwPv7/J00xIDOO7gsky26GBSXQrjZVZWqnVQltNyTY2IJqtlRg26T+To5n0U7OS79gokYnn9JtnWOJ4UMIPm14sSyIRhOA49rvgfNqppWL2pEbHa97tLfD2nCqFtsWE1GYMb7LWhkhHjgRdViGd2lUJcSdvYcFnZRVJib0NGIJiRCrOPbSZgGZPPwAnDCzIA13sruCsacEJxckGgDMPqelJRJGG+8usEWIT/S+DDHH7v3HqPn/UN9P+/cz/Pw+LzYCFKGDSAH9AAAAAElFTkSuQmCC" alt="">
              </div>
              <div v-if="promptInputTableInfo.thList[1].show" class="td-gender">{{item.gender==='NAN'?'男':'女'}}</div>
              <div v-if="promptInputTableInfo.thList[2].show" class="td-age">{{$calculateAge(item.birthday).years + '岁'+$calculateAge(item.birthday).months+ '月'}}</div>
              <div v-if="promptInputTableInfo.thList[3].show" class="td-phoneNumber">{{item.phoneNumber}}</div>
              <!--            <div v-if="promptInputTableInfo.thList[4].show" class="td-lastConsultation">{{item.ActiveDate.slice(0,9)+ ' '}} {{item.clinicName}}</div>-->
              <div v-if="promptInputTableInfo.thList[6].show" class="td-fileNo">{{item.caseNumber}}</div>
              <div v-if="promptInputTableInfo.thList[7].show" class="td-enterprise"></div>
              <div v-if="promptInputTableInfo.thList[8].show" class="td-homeAddress">{{item.address}}</div>
              <div v-if="promptInputTableInfo.thList[5].show" class="td-certificate">{{item.idNumber}}</div>
            </div>
          </div>
          <div class="setBtn">
            <i style="color: #9e9e9e" class="el-icon-setting"></i>
          </div>
        </div>

          <el-form-item prop="phoneNumber" class="form-item-reset" :show-message="false">
            <div class="phoneNumber">
              <el-input  type="text" :maxlength="11" placeholder="电话号"  v-model="patient.phoneNumber" prefix-icon="el-icon-phone"></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="emergencyPhone" class="form-item-reset" :show-message="false">
            <div class="phoneNumber">
              <el-input  type="text" :maxlength="11" placeholder="紧急联系电话"  v-model="patient.emergencyPhone"></el-input>
            </div>
          </el-form-item>

      </el-form>

      <div class="addUserBox" v-if="isOpenAddUserPop">
        <createOreditPatient @refresh-list="refreshList" :userInfoData="patient" type="新增患者" @close="closeCreateOreditPatient"/>
      </div>


    </div>
    <div v-if="patient.visitState ==='02' || patient.id" class="adduserBtn" @click="userInfoShowBoxShow = true">
      <svg t="1749129622818" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4738" width="128" height="128"><path d="M974.848 677.12l-153.6-153.6-307.2 307.2-21.248 169.728h444.16V916.48H735.232z m-179.2-12.032l23.808-23.552 35.584 35.584-23.552 23.552zM585.984 910.336l5.12-40.704L737.28 724.48l35.84 35.584-145.408 145.152z" p-id="4739" fill="#707070"></path><path d="M430.336 955.392c-6.144-10.752-12.544-21.504-19.968-32.768l-2.816-4.096h-261.12V874.24a341.76 341.76 0 0 1 312.32-340.736 289.536 289.536 0 0 1 32.256-1.536h5.632c44.288-3.328 103.936-13.568 136.448-42.496l15.36-12.032a252.416 252.416 0 0 0 98.304-199.68 256 256 0 0 0-512 0A251.904 251.904 0 0 0 332.8 477.44l2.304 1.792h-2.56a423.168 423.168 0 0 0-268.8 395.008v85.248a41.216 41.216 0 0 0 41.216 40.96h353.536l-9.984-14.848c-6.656-9.984-13.312-19.968-18.176-30.208zM317.952 277.76a173.056 173.056 0 1 1 173.056 171.776A172.544 172.544 0 0 1 317.952 277.76z" p-id="4740" fill="#707070"></path></svg>
    </div>
    <div v-if="patient.visitState !=='02' && !patient.id" class="adduserBtn" @click="isOpenAddUserPop = true">
      <svg t="1747742030672" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3445" width="32" height="32"><path d="M896.422 769.708H801.64v-95.081c0-17.868-14.49-32.404-32.302-32.404-17.812 0-32.302 14.536-32.302 32.404v95.081h-94.874c-17.812 0-32.302 14.536-32.302 32.404 0 17.868 14.49 32.403 32.302 32.403h94.782v95.081c0 17.869 14.49 32.404 32.302 32.404 17.812 0 32.301-14.535 32.301-32.404v-95.08h94.783c17.812 0 32.301-14.536 32.301-32.404 0-17.868-14.397-32.404-32.21-32.404zM478.73 829.324H161.648v-5.407c0.285-181.278 148.224-328.596 329.725-328.596 68.836 0 134.724 20.964 190.63 60.521 15.021 10.624 35.748 7.115 46.396-7.873 10.649-14.988 7.131-35.668-7.89-46.292-35.655-25.233-74.636-44.205-115.804-56.347 12.455-7.968 24.15-17.36 34.893-28.079 39.362-39.272 61.04-91.54 61.04-147.128 0-55.588-21.583-107.856-60.945-147.223C600.237 83.628 547.945 62 492.23 62s-108.102 21.628-147.464 60.9c-39.361 39.272-61.039 91.54-61.039 147.128 0 55.588 21.678 107.856 61.04 147.129 10.648 10.624 22.152 19.825 34.417 27.794-14.166 4.173-28.143 9.201-41.929 14.987-47.158 19.921-89.467 48.284-125.881 84.52-36.415 36.237-64.938 78.45-84.999 125.406C105.65 718.527 95.095 770.226 95 823.632v38.798c0 18.308 14.927 33.201 33.277 33.201h350.357c18.35 0 33.277-14.893 33.277-33.2 0-18.309-14.832-33.107-33.182-33.107z m13.5-700.922c78.343 0 142.045 63.556 142.045 141.721S570.573 411.844 492.23 411.844c-78.343 0-142.044-63.556-142.044-141.72 0-78.166 63.701-141.722 142.044-141.722z" fill="#515151" p-id="3446"></path></svg>
    </div>
  </div>
</template>

<script>
import createOreditPatient from "@/views/outpatientDoctorWorkstation/outpatientService/components/outpatientServiceContent/components/createOreditPatient";
import {get, post} from "@/api/api";
import {careerList} from "@/views/outpatientDoctorWorkstation/outpatientService/staticData.js";
export default {
  name: "index",
  props:['userInfoData'],
  components:{
    createOreditPatient
  },
  computed:{
    isFindPatient () {
      return this.$hasPermission('/outpatientDoctor/patient/findPatient');
    },
  },
  directives: {
    numeric: {
      bind(el, binding, vnode) {
        // 获取 Vue 实例
        const vm = vnode.context

        // 查找实际的 input 元素
        const findInput = (element) => {
          if (element.tagName === 'INPUT') return element
          return element.querySelector('input') || element
        }

        const inputEl = findInput(el)

        // 确保我们找到了 input 元素
        if (!inputEl || inputEl.tagName !== 'INPUT') {
          console.warn('v-numeric 指令需要应用在 input 元素上')
          return
        }

        let lastValidValue = inputEl.value

        const handleInput = (e) => {
          // 确保有值
          const value = e.target.value || ''

          // 过滤非数字字符
          const filteredValue = value.replace(/[^0-9]/g, '')

          // 限制最大值（119岁）
          let finalValue = filteredValue
          if (filteredValue && parseInt(filteredValue) > 119) {
            finalValue = '119'
          }

          // 只有值发生变化时才更新
          if (value !== finalValue) {
            // 保存光标位置
            const cursorPosition = e.target.selectionStart

            // 更新值
            e.target.value = finalValue

            // 触发 v-model 更新
            const event = new Event('input', { bubbles: true })
            e.target.dispatchEvent(event)

            // 恢复光标位置
            vm.$nextTick(() => {
              if (e.target.setSelectionRange) {
                const newPosition = Math.max(0, Math.min(cursorPosition, finalValue.length))
                e.target.setSelectionRange(newPosition, newPosition)
              }
            })
          }

          // 更新最后有效值
          lastValidValue = finalValue
        }

        // 添加事件监听
        inputEl.addEventListener('input', handleInput)

        // 处理粘贴事件
        inputEl.addEventListener('paste', (e) => {
          e.preventDefault()
          const text = (e.clipboardData || window.clipboardData).getData('text')
          const filtered = text.replace(/[^0-9]/g, '')
          document.execCommand('insertText', false, filtered)
        })

        // 存储处理函数以便解绑
        el._numericHandleInput = handleInput
      },

      unbind(el) {
        // 移除事件监听
        const inputEl = el.tagName === 'INPUT' ? el : el.querySelector('input')
        if (inputEl && el._numericHandleInput) {
          inputEl.removeEventListener('input', el._numericHandleInput)
        }
      }
    }
  },
  data() {
    return {
      cityList: [],
      cityCode: [],
      careerList,
      userInfoShowBoxShow: false,
      isOpenSearchPop: false,
      isOpenAddUserPop: false,
      promptInputTableInfo: {
        thList:[
          {
            code: 'name',
            label: '姓名',
            show: true
          },
          {
            code: 'gender',
            label: '性别',
            show: true
          },
          {
            code: 'age',
            label: '年龄',
            show: true
          },
          {
            code: 'phoneNumber',
            label: '手机号',
            show: true
          },
          {
            code: 'lastConsultation',
            label: '上次就诊',
            show: false
          },

          {
            code: 'fileNo',
            label: '档案号',
            show: true
          },
          {
            code: 'enterprise',
            label: '单位',
            show: false
          },
          {
            code: 'homeAddress',
            label: '家庭住址',
            show: true
          },
          {
            code: 'certificate',
            label: '证件',
            show: true
          }
        ],
        dataList:[]
      },
      isOkUserName: true,
      isOkAge: true,
      isOkMounth: true,
      isOkPhoneNumber: true,
      phoneNumberErrorType: 'empty', // 手机号错误类型：'empty'为空值，'format'为格式错误
      userNameThrottleFlag: 0, // 姓名输入节流标志
      phoneNumberThrottleFlag: 0, // 手机号输入节流标志
      patient:{},
      patientRules:{
        name:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        districtCode:[
          {required: true, message: '请选择现居住地',trigger:'submit'}
        ],
        job:[
          {required: true, message: '不能为空',trigger:'submit'}
        ],
        gender:[
          {required: true, message: '请选择性别',trigger:'submit'},
        ],
        weight:[
          {required: true, message: '请输入体重',trigger:'submit'},
        ],
        height:[
          {required: true, message: '请输入身高',trigger:'submit'},
        ],
        ageYear:[
          {
            validator: (rule, value, callback) => {
              if (!value && !this.patient.ageMonth) {
                callback(new Error('年龄不能为空'));
              } else {
                callback();
              }
            },
            trigger: 'submit'
          },
        ],
        ageMonth:[
          {
            validator: (rule, value, callback) => {
              if (!value && !this.patient.ageYear) {
                callback(new Error('年龄不能为空'));
              } else {
                callback();
              }
            },
            trigger: 'submit'
          },
        ],
        phoneNumber:[
          {required: false, message: '不能为空',trigger:'submit'},
          {pattern: /^1[3-9]\d{9}$/, message: '格式错误',trigger:'blur'},
          {validator: (rule, value, callback) => {
              if (!this.patient.phoneNumber && !this.patient.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话必填一项'));
              } else {
                callback();
              }
              if ((this.patient.phoneNumber && this.patient.emergencyPhone) && this.patient.phoneNumber  === this.patient.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话不能相同'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        emergencyPhone:[
          {required: false, message: '不能为空',trigger:'submit'},
          {pattern: /^1[3-9]\d{9}$/, message: '格式错误',trigger:'blur'},
          {validator: (rule, value, callback) => {
              if (!this.patient.phoneNumber && !this.patient.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话必填一项'));
              } else {
                callback();
              }
              if ((this.patient.phoneNumber && this.patient.emergencyPhone) && this.patient.phoneNumber  === this.patient.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话不能相同'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
      },
      patientRules2:{
        name:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        districtCode:[
          {required: true, message: '请选择现居住地',trigger:'submit'}
        ],
        job:[
          {required: true, message: '不能为空',trigger:'submit'}
        ],
        gender:[
          {required: true, message: '请选择性别',trigger:'submit'},
        ],
        ageYear:[
          {
            validator: (rule, value, callback) => {
              if (!value && !this.patient.ageMonth) {
                callback(new Error('年龄不能为空'));
              } else {
                callback();
              }
            },
            trigger: 'submit'
          },
        ],
        ageMonth:[
          {
            validator: (rule, value, callback) => {
              if (!value && !this.patient.ageYear) {
                callback(new Error('年龄不能为空'));
              } else {
                callback();
              }
            },
            trigger: 'submit'
          },
        ],
        phoneNumber:[
          {required: false, message: '不能为空',trigger:'submit'},
          {pattern: /^1[3-9]\d{9}$/, message: '格式错误',trigger:'blur'},
          {validator: (rule, value, callback) => {
              if (!this.patient.phoneNumber && !this.patient.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话必填一项'));
              } else {
                callback();
              }
              if ((this.patient.phoneNumber && this.patient.emergencyPhone) && this.patient.phoneNumber  === this.patient.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话不能相同'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        emergencyPhone:[
          {required: false, message: '不能为空',trigger:'submit'},
          {pattern: /^1[3-9]\d{9}$/, message: '格式错误',trigger:'blur'},
          {validator: (rule, value, callback) => {
              if (!this.patient.phoneNumber && !this.patient.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话必填一项'));
              } else {
                callback();
              }
              if ((this.patient.phoneNumber && this.patient.emergencyPhone) && this.patient.phoneNumber  === this.patient.emergencyPhone) {
                callback(new Error('手机号与紧急联系电话不能相同'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
      },
      userInfo:JSON.parse(localStorage.getItem('User')),

    }
  },
  watch: {
    '$store.state.nowPatientInfo':{
      handler(newValue) {
        // 确保 ageYear 是字符串且不为 null/undefined
        if (newValue) {
          if (newValue.ageYear == null) {
            newValue.ageYear = ''
          } else {
            newValue.ageYear = String(newValue.ageYear)
          }
        }

        this.cityCode = []
        this.patient = newValue

        if (this.patient.districtCode) {
          this.cityCode = [this.patient.provinceCode, this.patient.cityCode, this.patient.districtCode]
        }

        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate()
        }
      },
      deep: true,
      immediate: true
    },
    patient:{
      handler (newValue,oldValue) {
        console.log('nnnnn', newValue,oldValue)
        this.$store.commit('updatePatientByDraftId', newValue);
        // 移除重复的setNowPatientInfo调用，避免循环引用
        // 因为这个组件的patient是从store中获取的，不需要再次设置回store
      },
      deep:true,
    }
  },
  mounted() {
    // this.patient = this.$store.state.nowPatientInfo
    this.getCity()
  },
  methods:{
    changeCity (val) {
      this.patient.provinceCode = val[0]
      this.patient.cityCode = val[1]
      this.patient.districtCode = val[2]
      console.log(this.patient)
    },
    getCity () {
      get('/common/levelMetadata/getMetadataList').then(res=>{
        this.cityList = transformData(res.data.data.AreaCode)
        /**
         * 转换数据结构
         * @param {Array} data - 原始数据数组
         * @returns {Array} 转换后的新数组
         */
        function transformData(data) {
          if (!Array.isArray(data)) {
            return [];
          }

          return data.map(item => {
            const newItem = {
              label: item.name,
              value: item.code,
            };

            // 递归处理子项
            if (item.childList && item.childList.length > 0) {
              newItem.children = transformData(item.childList);
            }

            // 保留其他原始属性（如id）
            for (const key in item) {
              if (key !== 'name' && key !== 'code' && key !== 'childList') {
                newItem[key] = item[key];
              }
            }

            return newItem;
          });
        }
      })
    },
    refreshList () {
      this.$emit('refresh-list');
    },
    clearPatientInfo () {
      if (!this.patient.id) {
        console.warn('患者信息已清空，无需重复操作');
        return;
      }
      this.patient.name = '匿名患者';
      this.patient.gender = 'NAN';
      this.patient.ageYear = '';
      this.patient.birthday = '';
      this.patient.id = null;
      this.patient.visitState = '00';
      this.patient.provinceCode = null;
      this.patient.cityCode = null;
      this.patient.districtCode = null;
      this.patient.height = null;
      this.patient.weight = null;
      this.patient.job = null;
      this.patient.phoneNumber = null;
      this.patient.emergencyPhone = null;
      this.cityCode = [];
      this.isOpenSearchPop = false;
      console.log(this.patient);
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
        this.$forceUpdate();
      });
    },
    setBirthday () {
// 安全处理年龄值
      let ageYear = this.patient.ageYear

      // 处理空值
      if (!ageYear) {
        this.patient.birthday = ''
        return
      }

      // 确保是字符串
      if (typeof ageYear !== 'string') {
        ageYear = String(ageYear)
      }

      // 过滤非数字字符
      ageYear = ageYear.replace(/[^0-9]/g, '')

      // 限制最大值
      if (ageYear && parseInt(ageYear) > 119) {
        ageYear = '119'
        this.patient.ageYear = ageYear
      }

      // 计算生日
      this.patient.birthday = this.$calculateBirthDate(
          parseInt(ageYear || 0),
          parseInt(this.patient.ageMonth || 0),
          0
      )

      // 当输入年龄或月份时，重新校验两个字段以清除错误提示
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.validateField('ageYear')
          this.$refs.ruleForm.validateField('ageMonth')
        }
      })
    },
    hideSearchPop () {
      setTimeout(()=>{
        this.isOpenSearchPop = false
      },200)
    },
    // 更新患者信息
    setUnserInfo (item) {
      console.log(item)
      item.ageYear = this.$calculateAge(item.birthday).years
      console.log( item.ageYear,typeof  item.ageYear)
      let data = JSON.parse(JSON.stringify(item))
      if (this.patient.draftId) {
        data.draftId = this.patient.draftId
      }
      data.visitState = this.patient.visitState
      this.patient.name = data.name
      this.patient.gender = data.gender
      this.patient.ageYear = data.ageYear != null ? String(data.ageYear) : ''
      this.patient.birthday = data.birthday
      this.patient.id = data.id
      this.patient.provinceCode = data.provinceCode
      this.patient.cityCode = data.cityCode
      this.patient.districtCode = data.districtCode
      this.patient.height = data.height
      this.patient.weight = data.weight
      this.patient.job = data.job
      this.patient.caseNumber = data.caseNumber
      this.patient.phoneNumber = data.phoneNumber
      this.patient.emergencyPhone = data.emergencyPhone
    },
    closeCreateOreditPatient (v) {
      this.isOpenAddUserPop = false
      this.userInfoShowBoxShow = false
    },
    findPatient () {
      post('/outpatientDoctor/patient/findPatient',{name:this.patient.name,phoneNumber:this.patient.phoneNumber,pageNum:1,pageSize:20}).then(res=>{
        console.log(res)
        if (res.data.code === 200 && res.data.data.list.length!==0) {
          this.promptInputTableInfo.dataList = res.data.data.list
          this.isOpenSearchPop = true
        } else {
          this.promptInputTableInfo.dataList = []
        }
      })
    },
    changeUserName () {
      if (this.isFindPatient) {
        this.findPatient()
      }
    },

    //  表单校验手机号正确
    changePhonenumber () {
      if (this.isFindPatient) {
        this.findPatient()
      }
    },

    // 表单验证方法
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate((valid) => {

        });
      });
    },

    // 重置表单验证
    resetValidation() {
      this.$refs.ruleForm.clearValidate();
    },

    // 验证单个字段
    validateField(prop) {
      this.$refs.ruleForm.validateField(prop);
    }
  }
}
</script>

<style lang="less" scoped>
.nameGenderAgePhonenumberPiece{
  //
  display: flex;
  //flex-wrap: wrap;
  align-items: center;
  position: relative;
  .userInfoShowBox{
    position: absolute;
    width: 404px;
    height: 260px;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .15);
    top: 40px;
    left: 100px;
    z-index: 9999;
  }
  input{
    outline: none;
    font-size: 15px;
    background: transparent;
  }
  .waringUserNameInput{
    box-sizing: border-box;
    border: 1px solid var(--error-color) !important;
    background-color: var(--error-color2) !important;
    position: relative;
    &:hover::before{
      display: block;
      content: '不能为空';
      height: 20px;
      padding: 5px 10px;
      background-color: rgb(255,153,51);
      color: #fff;
      position: absolute;
      top: -37px;
      z-index: 99999;
      border-radius: 5px;
      font-size: 12px;
      width: 50px;
    }
    &:hover::after{
      display: block;
      content: '';
      background-color: rgb(255,153,51);
      position: absolute;
      top: -12px;
      left: 30px;
      width: 8px;
      height: 8px;
      transform: rotate(45deg);
    }
  }
  .userInfoInputPiece{
    height: 38px;
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 5px;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 10px;
    .marsk{
      position: absolute;
      //background-color: red;
      height: 100%;
      width: 100%;
      z-index: 1000;
      background-color: rgba(0,0,0,0.05);
      border-radius: 5px;
      left: 0;
    }
    .clearPatientInfo{
      position: absolute;
      z-index: 1000;
      right: 10px;
      user-select: none;
      i{
        font-size: 18px;
        color: rgba(96, 91, 91, 0.91);
        cursor: pointer;
        border-radius: 100px;
        position: relative;
        left: 10px;
      }
      :hover{
        transform: scale(1.3);
        color: #d30f0f;
      }
    }
    // 重置Element UI表单样式
    .patient-form {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      margin: 0;

      .form-item-reset {
        margin-bottom: 0 !important;
        height: 100%;
        display: flex;
        align-items: center;
        position: relative;
        
        .el-form-item__content {
          margin-left: 0 !important;
          height: 100%;
          display: flex;
          align-items: center;
          line-height: normal;
        }

        .el-form-item__error {
          position: absolute;
          top: 100%;
          left: 0;
          font-size: 12px;
          color: #f56c6c;
          background: #fff;
          padding: 2px 5px;
          border-radius: 3px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          z-index: 1000;
          white-space: nowrap;
        }
      }
    }
    .userNameBox{
      height: 100%;
      width: 118px;
      border-radius: 5px 0 0 5px;
      border: 1px solid transparent;
      display: flex;
      align-items: center;
      position: relative;
      i{
        font-size: 20px;
        margin-left: 10px;
        position: absolute;
        z-index: 999;
      }
      .userName{
        height: 100%;
        width: 100%;
        margin-left: 5px;
        border: none;
        background: transparent;
        font-size: 15px;
        outline: none;
        padding-left: 20px;
        &::placeholder {
          color: #cbcbd0;
        }
      }
    }
    .genderBox{
      height: 100%;
      width: 100px;
      display: flex;
      align-items: center;
      //border-top: 1px solid rgba(0,0,0,0.1);
      //border-bottom: 1px solid rgba(0,0,0,0.1);
      border-radius: 0;
      box-sizing: border-box;
      gap: 4px;
      .must {
        position: relative;
        left: -9px;
      }
    }
    .locationBox{
      height: 100%;
      display: flex;
      align-items: center;
      gap: 4px;
      position: relative;
      .must {
        position: absolute;
        left: -2px;
        top: -2px;
      }
      .locationIcon {
        height: 18px;
        width: 18px;
        margin-left: 15px;
      }
    }
    .jobBox{
      height: 100%;
      display: flex;
      align-items: center;
      gap: 4px;
      position: relative;
      .must {
        position: absolute;
        left: -2px;
        top: -2px;
      }
      .jobIcon {
        height: 18px;
        width: 18px;
        margin-left: 15px;
      }
    }
    .ageBox{
      height: 100%;
      width:68px;
      //
      border: 1px solid transparent;
      cursor: pointer;
      display: flex;
      align-items: center;
      .age{
        width: 100%;
        height: 100%;
        text-align: right;
      }
      .label{
        font-size: 15px;
      }
    }
    .weightBox {
      height: 100%;
      width:79px;
      //
      border: 1px solid transparent;
      cursor: pointer;
      display: flex;
      align-items: center;
    }
    .phoneNumber {
      width:140px;
    }
    .mounthBox{
      height: 100%;
      width: 60px;
      //
      border: 1px solid transparent;
      display: flex;
      align-items: center;
      .mounth{
        width: 100%;
        height: 100%;
        text-align: right;
      }
      .label{
        font-size: 15px;
      }
    }
    .phonenumberBox{
      height: 100%;
      width: 160px;
      border-radius: 0 5px 5px 0;
      border: 1px solid transparent;
      .phonenumber{
        width: 100%;
        height: 100%;
        border: 1px solid transparent;
      }
    }
    @keyframes openBox {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    .promptInputBox{
      height: auto;
      position: absolute;
      background: linear-gradient(135deg, #FFFEF7 0%, #FFF8DC 100%);
      border: 1px solid #DEB887;
      border-radius: 5px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      top: 40px;
      animation: openBox ease-in-out 0.2s;
      max-width: 898px;
      box-shadow: 0 4px 12px rgba(139, 69, 19, 0.2);
      z-index: 100;
      .tr-head{
        height: 30px;
        display: flex;
        align-items: center;
        gap: 5px;
        background: linear-gradient(135deg, #F5DEB3 0%, #DEB887 100%);
        color: #8B4513;
        font-size: 12px;
        font-weight: 700;
        border-bottom: 1px solid #e0e5ee;
        padding: 0 5px;
        div:nth-child(1){
          margin-left: 20px;
        }
        div:nth-last-child(1){
          margin-right: 5px;
        }
        .td-name{
          height: 100%;
          width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 36px;

        }
        .td-gender{
          height: 100%;
          width: 28px;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 36px;

        }
        .td-age{
          height: 100%;
          width: 84px;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 36px;

        }
        .td-phoneNumber{
          height: 100%;
          width: 88px;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 36px;

        }
        .td-lastConsultation{
          height: 100%;
          width: 132px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 36px;

        }
        .td-fileNo{
          height: 100%;
          width: 70px;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 36px;
        }
        .td-enterprise{
          height: 100%;
          width: 70px;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 36px;
        }
        .td-homeAddress{
          height: 100%;
          width: 98px;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 36px;
        }
        .td-certificate{
          height: 100%;
          width: 144px;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 36px;
        }
      }
      .tableBody{
        display: flex;
        flex-direction: column;
        font-size: 14px;
        padding: 0 5px;
        margin-top: 5px;
        max-height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
        .tr{
          display: flex;
          align-items: center;
          gap: 5px;
          height: 36px;
          border-bottom: 1px dashed #e0e5ee;
          cursor: pointer;
          background-color: #fff;
          &:hover{
            background-color: #F5F5F5;
            border-radius: 5px;
          }
          div:nth-child(1){
            margin-left: 20px;
          }
          div:nth-last-child(1){
            margin-right: 5px;
          }
          .td-name{
            height: 100%;
            width: 80px;
           display: flex;
            align-items: center;
            gap: 2px;
            .vipIcon{
              height: 12px;
              width: 12px;
            }
          }
          .td-gender{
            height: 100%;
            width: 28px;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 36px;
          }
          .td-age{
            height: 100%;
            width: 84px;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 36px;

          }
          .td-phoneNumber{
            height: 100%;
            width: 88px;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 36px;

          }
          .td-lastConsultation{
            height: 100%;
            width: 132px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 36px;

          }
          .td-fileNo{
            height: 100%;
            width: 48px;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 36px;
          }
          .td-enterprise{
            height: 100%;
            width: 70px;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 36px;
          }
          .td-homeAddress{
            height: 100%;
            width: 98px;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 36px;
          }
          .td-certificate{
            height: 100%;
            width: 144px;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 36px;
          }
        }
        .tr:nth-child(1){
          background-color: #5199f8;
          border-radius: 5px;
          color: #fff;
          border-bottom:none;
        }
        .tr:nth-last-child(1){
          border-bottom: 1px solid #e0e5ee;
        }
      }
      .setBtn{
        height: 32px;
        background-color: #f9fafc;
        display: flex;
        align-items: center;
        padding: 0 10px;
        justify-content: flex-end;
        cursor: pointer;
      }
    }
  }
  .addUserBox{
    position: absolute;
    width: 404px;
    height: 300px;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .15);
    top: 40px;
    left: 220px;
    padding: 10px;
    z-index: 9999;
  }
  .adduserBtn{
    height: 39px;
    width: 40px;
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 5px;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 5px;
    cursor: pointer;
    position: relative;
    svg{
      height: 19px;
      width: 19px;
    }
    &:hover{
      background-color: #e0e5ee;
    }
    &:active{
      background-color: #d9dde0;
    }
  }

  /deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus, .el-message-box__input input.invalid, .el-message-box__input input.invalid:focus{
    border: 1px solid var(--error-color) !important;
    background-color: var(--error-color2) !important;
  }
  /deep/.el-form-item__error {
    font-size: 12px;
    position: absolute;
    top: -59%;
    left: 5%;
    background: var(--error-color);
    padding: 7px;
    border-radius: 3px;
    color: #fff;
  }
}
/deep/.el-form-item{
  margin: 0;
}
/deep/.el-form-item__content{
  margin: 0 !important;
  padding: 0;
}
/deep/.el-input__inner{
  text-align: left;
  border: none;
  background-color: transparent;
  //border: 1px solid red;
}
/deep/.el-input__icon {
  font-size: 18px;
  line-height: 32px;
}
.must{
  color: red;
  font-size: 18px;
  font-weight: 900;
  position: absolute;
  top: -2px;
}
.must2{
  color: red;
  font-size: 18px;
  font-weight: 900;
  position: absolute;
  top: -2px;
  right: 21px;
}
.genderIcon {
  height: 20px;
  width: 20px;
}
</style>
